<div class="flex flex-col w-full mt-8 sm:mt-2   pb-0 sm:p-6  sm:pt-1 sm:pb-0 shadow rounded-2xl bg-card mb-6">

    <div class="flex flex-col w-full">
        <div class="flex pt-2">
            <div class="w-1/2">
                <label class="text-2xl font-bold tracking-tight">Séances</label>
            </div>

            <div class="flex w-1/2 pr-l text-right">

                <div class="w-2/3"></div>
                <div class="w-1/2">

                </div>
            </div>
        </div>
    </div>
    <div class="flex">
        <div class="flex flex-col flex-auto  mt-8 sm:mt-6 p-0.5 rounded-full mb-8 sm:mb-16">
            <table mat-table [dataSource]="dataSource" class="mat-elevation-z1 w-full">
                <ng-container matColumnDef="id">
                    <th mat-header-cell *matHeaderCellDef> No. </th>
                    <td mat-cell *matCellDef="let element" class="text">{{element.id}} </td>
                </ng-container>
                <ng-container matColumnDef="nomprenom">
                    <th mat-header-cell *matHeaderCellDef> Nom et Prénom </th>
                    <td mat-cell *matCellDef="let element" class="text">
                        <a class="whitespace-nowrap text-primary-500"
                            [routerLink]="['/abonnes/show/'+element.abonne_id]"
                            routerLinkActive="router-link-active">{{element.nomprenom}}</a>
                    </td>
                </ng-container>
                <ng-container matColumnDef="date_seance">
                    <th mat-header-cell *matHeaderCellDef> Date Sceance </th>
                    <td mat-cell *matCellDef="let element" class="text"> {{element.date_seance | date}}</td>
                </ng-container>
                <ng-container matColumnDef="heure_debut">
                    <th mat-header-cell *matHeaderCellDef> Heure debut </th>
                    <td mat-cell *matCellDef="let element" class="text"> {{element.heure_debut}}</td>
                </ng-container>
                <ng-container matColumnDef="heure_fin">
                    <th mat-header-cell *matHeaderCellDef> Heure fin </th>
                    <td mat-cell *matCellDef="let element" class="text"> {{element.heure_fin}}</td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let element;let row; columns: displayedColumns;"></tr>
            </table>

        </div>
    </div>
</div>